module.exports = __webpack_public_path__ + "static/media/Spinarak_gaussian2.5f427698.png";